import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'bookmarkFolders/FETCH_REQUEST'
const FETCH_SUCCESS = 'bookmarkFolders/FETCH_SUCCESS'
const FETCH_FAILURE = 'bookmarkFolders/FETCH_FAILURE'
const CREATE_REQUEST = 'bookmarkFolders/CREATE_REQUEST'
const CREATE_SUCCESS = 'bookmarkFolders/CREATE_SUCCESS'
const CREATE_FAILURE = 'bookmarkFolders/CREATE_FAILURE'
const UPDATE_REQUEST = 'bookmarkFolders/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'bookmarkFolders/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'bookmarkFolders/UPDATE_FAILURE'
const UPDATE_BOOKMARK_REQUEST = 'bookmarkFolders/UPDATE_BOOKMARK_REQUEST'
const UPDATE_BOOKMARK_SUCCESS = 'bookmarkFolders/UPDATE_BOOKMARK_SUCCESS'
const UPDATE_BOOKMARK_FAILURE = 'bookmarkFolders/UPDATE_BOOKMARK_FAILURE'
const DEFAULT_REQUEST = 'bookmarkFolders/DEFAULT_REQUEST'
const DEFAULT_SUCCESS = 'bookmarkFolders/DEFAULT_SUCCESS'
const DEFAULT_FAILURE = 'bookmarkFolders/DEFAULT_FAILURE'
const DELETE_REQUEST = 'bookmarkFolders/DELETE_REQUEST'
const DELETE_SUCCESS = 'bookmarkFolders/DELETE_SUCCESS'
const DELETE_FAILURE = 'bookmarkFolders/DELETE_FAILURE'
const DELETE_BOOKMARK_REQUEST = 'bookmarkFolders/DELETE_BOOKMARK_REQUEST'
const DELETE_BOOKMARK_SUCCESS = 'bookmarkFolders/DELETE_BOOKMARK_SUCCESS'
const DELETE_BOOKMARK_FAILURE = 'bookmarkFolders/DELETE_BOOKMARK_FAILURE'
const CREATE_POWER_LIST_REQUEST = 'bookmarkFolders/CREATE_POWER_LIST_REQUEST'
const CREATE_POWER_LIST_SUCCESS = 'bookmarkFolders/CREATE_POWER_LIST_SUCCESS'
const CREATE_POWER_LIST_FAILURE = 'bookmarkFolders/CREATE_POWER_LIST_FAILURE'
const RESET_POWER_LIST_REQUEST = 'bookmarkFolders/RESET_POWER_LIST_REQUEST';

const initialState = {
  result: {records: [], page: 1, total_count: 0},
  loading: false,
  loaded: false,
  creating: false,
  created: false,
  updating: false,
  updated: false,
  updatingBookmark: false,
  updatedBookmark: false,
  deleting: false,
  deleted: false,
  deletingBookmark: false,
  deletedBookmark: false,
  makingDefault: false,
  defaultMade: false,
  powerListCreating: false,
  powerListCreated: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload) {
  return {
    type: CREATE_SUCCESS,
    payload,
  }
}

export function createFailure(errors) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function updateBookmarkRequest() {
  return {
    type: UPDATE_BOOKMARK_REQUEST,
  }
}

export function updateBookmarkSuccess(payload) {
  return {
    type: UPDATE_BOOKMARK_SUCCESS,
    payload,
  }
}

export function updateBookmarkFailure(errors) {
  return {
    type: UPDATE_BOOKMARK_FAILURE,
    errors,
  }
}

export function markDefaultRequest() {
  return {
    type: DEFAULT_REQUEST,
  }
}

export function markDefaultSuccess(payload) {
  return {
    type: DEFAULT_SUCCESS,
    payload,
  }
}

export function markDefaultFailure(errors) {
  return {
    type: DEFAULT_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload) {
  return {
    type: DELETE_SUCCESS,
    payload,
  }
}

export function deleteFailure(errors) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function deleteBookmarkRequest() {
  return {
    type: DELETE_BOOKMARK_REQUEST,
  }
}

export function deleteBookmarkSuccess(payload) {
  return {
    type: DELETE_BOOKMARK_SUCCESS,
    payload,
  }
}

export function deleteBookmarkFailure(errors) {
  return {
    type: DELETE_BOOKMARK_FAILURE,
    errors,
  }
}

export function createPowerListRequest() {
  return {
    type: CREATE_POWER_LIST_REQUEST,
  }
}

export function createPowerListSuccess(payload) {
  return {
    type: CREATE_POWER_LIST_SUCCESS,
    payload,
  }
}

export function createPowerListFailure(errors) {
  return {
    type: CREATE_POWER_LIST_FAILURE,
    errors,
  }
}

export function resetPowerListRequest(){
  return {
    type: RESET_POWER_LIST_REQUEST
  }
}

export function newPowerList() {
  return(dispatch) => {
    dispatch(resetPowerListRequest());
  }
}

export function loadBookmarkFolders(options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/bookmark_folders`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function createBookmarkFolder(options = {}) {
  const config = {
    method: 'POST',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(createRequest())

    return api(`api/v1/bookmark_folders`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(createSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(createFailure(errors))
        })
      })
  }
}

export function updateBookmarkFolder(id, options = {}) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateRequest())

    return api(`api/v1/bookmark_folders/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function updateBookmark(id, options = {}) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateBookmarkRequest())

    return api(`api/v1/bookmarks/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateBookmarkSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateBookmarkFailure(errors))
        })
      })
  }
}

export function markDefaultBookmarkFolder(id) {
  const config = {
    method: 'PUT'
  }

  return (dispatch) => {
    dispatch(markDefaultRequest())

    return api(`api/v1/bookmark_folders/${id}/mark_default`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(markDefaultSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(markDefaultFailure(errors))
        })
      })
  }
}

export function deleteBookmarkFolder(id) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    return api(`api/v1/bookmark_folders/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(deleteSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(deleteFailure(errors))
        })
      })
  }
}

export function deleteBookmark(id) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteBookmarkRequest())

    return api(`api/v1/bookmarks/${id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(deleteBookmarkSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(deleteBookmarkFailure(errors))
        })
      })
  }
}

export function createPowerList(options, cb) {
  const config = {
    method: 'POST',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(createPowerListRequest())

    return api(`api/v1/bookmark_folders/power_list`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(createPowerListSuccess(json))

        cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(createPowerListFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: errors
      }
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        created: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([], [payload, ...state.result.records])})
      })
    case CREATE_FAILURE:
      return {
        ...state,
        errors: errors,
        creating: false,
        created: false
      }
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      const updatedIndex = state.result.records.findIndex(i => i.id === payload.id)
      
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([...state.result.records], {[updatedIndex]: payload})})
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false
      }
    case UPDATE_BOOKMARK_REQUEST:
      return Object.assign({}, state, {
        updatingBookmark: true
      })
    case UPDATE_BOOKMARK_SUCCESS:
      const folderIndex = state.result.records.findIndex(i => i.id === payload.bookmark_folder.id)
      const folderBIndex = state.result.records[folderIndex].bookmarks.findIndex(i => i.id === payload.id)
      return Object.assign({}, state, {
        updatingBookmark: false,
        updatedBookmark: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([...state.result.records], {[folderIndex]:
          Object.assign({}, {...state.result.records[folderIndex],
            bookmarks: Object.assign([...state.result.records[folderIndex].bookmarks],
                {[folderBIndex]: payload})})})})
      })
    case UPDATE_BOOKMARK_FAILURE:
      return {
        ...state,
        errors: errors,
        updatingBookmark: false,
        updatedBookmark: false
      }
    case DEFAULT_REQUEST:
      return Object.assign({}, state, {
        makingDefault: true
      })
    case DEFAULT_SUCCESS:
      const previousIndex = state.result.records.findIndex(i => i.id === payload.previous.id)
      const bookmarkIndex = state.result.records.findIndex(i => i.id === payload.bookmark.id)
      return Object.assign({}, state, {
        makingDefault: false,
        defaultMade: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([...state.result.records],
          {[previousIndex]: payload.previous, [bookmarkIndex]: payload.bookmark})})
      })
    case DEFAULT_FAILURE:
      return {
        ...state,
        errors: errors,
        makingDefault: false,
        defaultMade: false
      }
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true
      })
    case DELETE_SUCCESS:
      const filteredResult = state.result.records.filter( i => i.id !== payload.id )
      return Object.assign({}, state, {
        deleting: false,
        deleted: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([], filteredResult)})
      })
    case DELETE_FAILURE:
      return {
        ...state,
        errors: errors,
        deleting: false,
        deleted: false
      }
    case DELETE_BOOKMARK_REQUEST:
      return Object.assign({}, state, {
        deletingBookmark: true
      })
    case DELETE_BOOKMARK_SUCCESS:
      const folderId = state.result.records.findIndex(i => i.id === payload.folder_id)
      return Object.assign({}, state, {
        deletingBookmark: false,
        deletedBookmark: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([...state.result.records], {[folderId]:
            Object.assign({}, {...state.result.records[folderId],
              bookmarks: [...state.result.records[folderId].bookmarks].filter((bookmark) => bookmark.id !== payload.id)})})})
      })
    case DELETE_BOOKMARK_FAILURE:
      return {
        ...state,
        errors: errors,
        deletingBookmark: false,
        deletedBookmark: false
      }
    case CREATE_POWER_LIST_REQUEST:
      return Object.assign({}, state, {
        powerListCreating: true
      })
    case CREATE_POWER_LIST_SUCCESS:
      return Object.assign({}, state, {
        powerListCreating: false,
        powerListCreated: true,
        errors: [],
        result: Object.assign({}, {...state.result, records: Object.assign([], [payload, ...state.result.records])})
      })
    case CREATE_POWER_LIST_FAILURE:
      return {
        ...state,
        errors: errors,
        powerListCreating: false,
        powerListCreated: false
      }
    case RESET_POWER_LIST_REQUEST:
      return Object.assign({}, state, {
        powerListCreated: false
      })
    default:
      return state
  }
}

